import { useSearchParams } from '@remix-run/react'
import * as React from 'react'

type ArticleGridProps = {
	children: React.ReactNode
}

export const ArticleGrid = ({ children }: ArticleGridProps) => {
	const [searchParams] = useSearchParams()

	React.useEffect(() => {
		function resize() {
			const grid = document.querySelector('#masonry') as HTMLElement
			const rowHeight = getStyleValue(grid, 'grid-auto-rows')
			const rowGap = getStyleValue(grid, 'grid-row-gap')

			if (grid) {
				grid.style.gridAutoRows = 'auto'
				grid.style.alignItems = 'self-start'
				grid.querySelectorAll('.item').forEach(item => {
					;(item as HTMLElement).style.gridRowEnd = `span ${Math.ceil(
						(item.clientHeight + rowGap) / (rowHeight + rowGap),
					)}`
				})
				grid.removeAttribute('style')
			}
		}

		function getStyleValue(element: HTMLElement, style: string) {
			return parseInt(window.getComputedStyle(element).getPropertyValue(style))
		}

		if (document.readyState === 'complete') {
			console.log('document readyState is complete')
			console.log(''.padEnd(50, '^'))
			resize()
		} else {
			window.addEventListener('load', resize)

			return () => window.removeEventListener('load', resize)
		}
	}, [searchParams])

	return (
		<div
			id="masonry"
			className="lg:grid-cols-masonry grid max-w-[1280px] flex-grow auto-rows-[20px] gap-2.5 px-4"
		>
			{children}
		</div>
	)
}
